"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoodooAbilityHandler = exports.HoodooActorAbilityFactory = exports.HoodooAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class HoodooAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Hoodoo;
        this.__typeName = "Hoodoo";
    }
}
exports.HoodooAbilityArgs = HoodooAbilityArgs;
let HoodooActorAbilityFactory = class HoodooActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Hoodoo", "OneEnemies", 3);
    }
};
HoodooActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Hoodoo")
], HoodooActorAbilityFactory);
exports.HoodooActorAbilityFactory = HoodooActorAbilityFactory;
let HoodooAbilityHandler = class HoodooAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let targetIds = ability.args.target.actorIds.slice(0, 1);
        if (container.hasAttribute(ability.invokerId, "Charm_Augur_1")) {
            targetIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        }
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            targets: targetIds.map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 80)
                ]
            })),
            onHit(sequence, { targetId }) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "DarkLightning"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Vitality, 10),
                        new core_1.LinkedEventHandlerEffectArgs("Hoodoo", "Something is watching you.", true, container.registerEventHandlerScript(targetId, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, "Ability_Hoodoo", {
                            casterId: ability.invokerId
                        }))
                    ], true)
                });
            }
        });
    }
};
HoodooAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Hoodoo)
], HoodooAbilityHandler);
exports.HoodooAbilityHandler = HoodooAbilityHandler;
